import administration from './locales/en/administration.json';
import chat from './locales/en/chat.json';
import common from './locales/en/common.json';
import errors from './locales/en/errors.json';
import legal from './locales/en/legal.json';
import match from './locales/en/match.json';
import menu from './locales/en/menu.json';
import music from './locales/en/music.json';
import online from './locales/en/online.json';
import settings from './locales/en/settings.json';
import inventory from './locales/en/inventory.json';
import ptBrAdministration from './locales/pt-BR/administration.json';
import ptBrChat from './locales/pt-BR/chat.json';
import ptBrCommon from './locales/pt-BR/common.json';
import ptBrErrors from './locales/pt-BR/errors.json';
import ptBrLegal from './locales/pt-BR/legal.json';
import ptBrMatch from './locales/pt-BR/match.json';
import ptBrMenu from './locales/pt-BR/menu.json';
import ptBrMusic from './locales/pt-BR/music.json';
import ptBrOnline from './locales/pt-BR/online.json';
import ptBrSettings from './locales/pt-BR/settings.json';
import ptBrInventory from './locales/pt-BR/inventory.json';

export const englishCatalog = {
  common,
  menu,
  match,
  online,
  settings,
  chat,
  music,
  administration,
  legal,
  errors,
  inventory,
} as const;

export const brazilianPortugueseCatalog = {
  common: ptBrCommon,
  menu: ptBrMenu,
  match: ptBrMatch,
  online: ptBrOnline,
  settings: ptBrSettings,
  chat: ptBrChat,
  music: ptBrMusic,
  administration: ptBrAdministration,
  legal: ptBrLegal,
  errors: ptBrErrors,
  inventory: ptBrInventory,
} as const;

export type AppNamespace = keyof typeof englishCatalog;

export interface TranslationResource {
  readonly [key: string]: string | TranslationResource;
}

export type AppCatalog = Readonly<Record<AppNamespace, TranslationResource>>;

export const bundledCatalogs = {
  en: englishCatalog,
  'pt-BR': brazilianPortugueseCatalog,
} as const satisfies Record<string, AppCatalog>;

export type BundledLocale = keyof typeof bundledCatalogs;
